module.exports = __webpack_public_path__ + "static/media/BlurredBG.cf9d8b8b.svg";